export const environment = {
    production: false,
    apiPath: "https://testbackend.luftmengenberechnung.com"
};
